
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.1818 8.5H16.3636C16.8412 8.5 17.314 8.59053 17.7552 8.76642C18.1964 8.94231 18.5973 9.20012 18.9349 9.52513C19.2726 9.85013 19.5405 10.236 19.7232 10.6606C19.9059 11.0852 20 11.5404 20 12C20 12.4596 19.9059 12.9148 19.7232 13.3394C19.5405 13.764 19.2726 14.1499 18.9349 14.4749C18.5973 14.7999 18.1964 15.0577 17.7552 15.2336C17.314 15.4095 16.8412 15.5 16.3636 15.5H14.1818M9.81818 15.5H7.63636C7.15883 15.5 6.68597 15.4095 6.24479 15.2336C5.8036 15.0577 5.40273 14.7999 5.06507 14.4749C4.38312 13.8185 4 12.9283 4 12C4 11.0717 4.38312 10.1815 5.06507 9.52513C5.74702 8.86875 6.67194 8.5 7.63636 8.5H9.81818M9.09091 12H14.9091","stroke":"#10001F","stroke-width":"1.6","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    